import { useEffect, useState } from "react";

export default function GoogleRedirect() {
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) {
      setError("Google did not send a sign-in code. Please start again from the login page.");
      return;
    }
    // Hand the code to the backend, which exchanges it with Google and sets the session.
    const redirectUri = window.location.origin + "/auth/google";
    window.location.href =
      `/api/auth/google/finish?code=${encodeURIComponent(code)}` +
      `&state=${encodeURIComponent(params.get("state") || "")}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}`;
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-bg p-6" data-testid="google-redirect-page">
      {error ? (
        <div className="w-full max-w-sm rounded-2xl border border-line bg-surface p-8 text-center">
          <p className="font-display text-2xl font-extrabold">Google sign-in did not complete</p>
          <p className="mt-2 text-sm text-muted" data-testid="google-redirect-error">{error}</p>
          <a href="/login" className="mt-6 inline-block rounded-full bg-accent px-6 py-2.5 text-sm font-bold text-white">
            Back to login
          </a>
        </div>
      ) : (
        <p className="font-mono text-sm text-muted" data-testid="google-redirect-status">Finishing Google sign-in…</p>
      )}
    </div>
  );
}
